import { z } from 'zod';

import { parseConfig } from './parse-config';

export const domainSchema = z.string().default('localhost');

export const domain = parseConfig('domain configuration', domainSchema, process.env.DOMAIN);
